import { sportNameFromId } from '@/pages/order/components/productHelpers';

export const SPORT_IDS = {
  cfb: 1,
  cbb: 2,
  nfl: 3,
  wnba: 4,
  nba: 5,
  ufl: 6,
  cbase: 7,
  cfl: 8,
};

export type SportName = keyof typeof SPORT_IDS;

export function filterUrl(
  baseUrl: string,
  sportId: string | number | undefined,
  seasonId: string | number | undefined,
  seasonName: string | undefined,
) {
  return (
    baseUrl +
    (sportId && sportId !== '0' && sportId !== 'ras'
      ? `/${sportNameFromId(parseInt(`${sportId}`, 10)) || sportId}`
      : baseUrl === '/results'
        ? ''
        : '/ras') +
    (seasonId && seasonId !== 'current'
      ? `/season/${seasonId}` +
        (seasonName ? `--${seasonName.replace(/[^a-zA-Z0-9_]+/g, '-')}` : '')
      : '')
  );
}
